module.exports = __webpack_public_path__ + "static/media/USDA organic logo- badge vector-03.04c3ac19.jpg";